import React from 'react'

import i18n from 'modules/core/lib/i18n'

import { useItemProvider } from 'modules/processes/components/ItemWizard/Providers/item'
import { TaskTypes } from 'modules/processes/hooks/types'
import { TaskConfigurationTypes } from 'modules/processes/lib/taskConfigurationTypes'

import TaskCard from '../../../../components/ItemCard'

interface Props {
  onSelect: (taskType: TaskTypes) => void
}

const Selector = ({ onSelect }: Props) => {
  const { itemType } = useItemProvider()

  return (
    <TaskCard
      title={i18n.t('processes.process_settings.wizard.tasks.types.upload_document.title')}
      description={i18n.t(
        'processes.process_settings.wizard.tasks.types.upload_document.description'
      )}
      onSelect={() => {
        onSelect(TaskConfigurationTypes.UploadDocument)
      }}
      itemType={TaskConfigurationTypes.UploadDocument}
      value={itemType}
    />
  )
}

export default Selector
